/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
document.addEventListener("DOMContentLoaded", function() {
  function formatDate(date) {
    return date.toLocaleDateString('en-US', {
      weekday: 'short',
      month: 'short',
      day: 'numeric'
    });
  }

  function addBusinessDays(date, days) {
    let result = new Date(date);
    let added = 0;
    while (added < days) {
      result.setDate(result.getDate() + 1);
      if (result.getDay() !== 0 && result.getDay() !== 6) {
        added++;
      }
    }
    return result;
  }

  // === YOUR DELIVERY SETTINGS ===
  // Production: Ships in 3–5 business days
  // Transit: 2–4 business days

  const today = new Date();

  const shipFrom = addBusinessDays(today, 3);
  const shipTo   = addBusinessDays(today, 5);

  const deliverFrom = addBusinessDays(shipFrom, 2);
  const deliverTo   = addBusinessDays(shipTo, 4);

  const fromSpan = document.getElementById("fromDate");
  const toSpan   = document.getElementById("toDate");

  if (fromSpan && toSpan) {
    fromSpan.textContent = formatDate(deliverFrom);
    toSpan.textContent   = formatDate(deliverTo);
  }
});